"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Pear MAMI API
 * Track all your events!
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultApi = exports.DefaultApiFactory = exports.DefaultApiFp = exports.DefaultApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * DefaultApi - axios parameter creator
 * @export
 */
exports.DefaultApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Report on the status of mami service, in the given environment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1HealthGet: (options = {}) => __awaiter(this, void 0, void 0, function* () {
            const localVarPath = `/v1/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Lists actors\' events. Optionally filtered by event names and/or program. Adds limits to queries per actor and ability sort by value.
         * @summary List events for given actors (Patients or Staff). Required Scopes: mami-event-list
         * @param {EventListPayloadDTO} eventListPayloadDTO A payload that contains actor_ids, event_names, limit, and sort_by
         * @param {string} [program] A program to filter for actors by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ListPost: (eventListPayloadDTO, program, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'eventListPayloadDTO' is not null or undefined
            common_1.assertParamExists('v1ListPost', 'eventListPayloadDTO', eventListPayloadDTO);
            const localVarPath = `/v1/list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication OAuth2 required
            // oauth required
            yield common_1.setOAuthToObject(localVarHeaderParameter, "OAuth2", ["mami-events-list"], configuration);
            // authentication bearerAuth required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (program !== undefined && program !== null) {
                localVarHeaderParameter['program'] = String(program);
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(eventListPayloadDTO, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<TrackEventPayloadDTO>} trackEventPayloadDTO Details about the events in question, and their context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2TrackBatchPost: (trackEventPayloadDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'trackEventPayloadDTO' is not null or undefined
            common_1.assertParamExists('v2TrackBatchPost', 'trackEventPayloadDTO', trackEventPayloadDTO);
            const localVarPath = `/v2/trackBatch`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(trackEventPayloadDTO, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         * Report one event MAMI which validates and records it.
         * @param {TrackEventPayloadDTO} trackEventPayloadDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2TrackPost: (trackEventPayloadDTO, options = {}) => __awaiter(this, void 0, void 0, function* () {
            // verify required parameter 'trackEventPayloadDTO' is not null or undefined
            common_1.assertParamExists('v2TrackPost', 'trackEventPayloadDTO', trackEventPayloadDTO);
            const localVarPath = `/v2/track`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication bearerAuth required
            // http bearer authentication required
            yield common_1.setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json';
            common_1.setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = common_1.serializeDataIfNeeded(trackEventPayloadDTO, localVarRequestOptions, configuration);
            return {
                url: common_1.toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
/**
 * DefaultApi - functional programming interface
 * @export
 */
exports.DefaultApiFp = function (configuration) {
    const localVarAxiosParamCreator = exports.DefaultApiAxiosParamCreator(configuration);
    return {
        /**
         * Report on the status of mami service, in the given environment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1HealthGet(options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1HealthGet(options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Lists actors\' events. Optionally filtered by event names and/or program. Adds limits to queries per actor and ability sort by value.
         * @summary List events for given actors (Patients or Staff). Required Scopes: mami-event-list
         * @param {EventListPayloadDTO} eventListPayloadDTO A payload that contains actor_ids, event_names, limit, and sort_by
         * @param {string} [program] A program to filter for actors by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ListPost(eventListPayloadDTO, program, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v1ListPost(eventListPayloadDTO, program, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         *
         * @param {Array<TrackEventPayloadDTO>} trackEventPayloadDTO Details about the events in question, and their context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2TrackBatchPost(trackEventPayloadDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2TrackBatchPost(trackEventPayloadDTO, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
        /**
         * Report one event MAMI which validates and records it.
         * @param {TrackEventPayloadDTO} trackEventPayloadDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2TrackPost(trackEventPayloadDTO, options) {
            return __awaiter(this, void 0, void 0, function* () {
                const localVarAxiosArgs = yield localVarAxiosParamCreator.v2TrackPost(trackEventPayloadDTO, options);
                return common_1.createRequestFunction(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration);
            });
        },
    };
};
/**
 * DefaultApi - factory interface
 * @export
 */
exports.DefaultApiFactory = function (configuration, basePath, axios) {
    const localVarFp = exports.DefaultApiFp(configuration);
    return {
        /**
         * Report on the status of mami service, in the given environment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1HealthGet(options) {
            return localVarFp.v1HealthGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Lists actors\' events. Optionally filtered by event names and/or program. Adds limits to queries per actor and ability sort by value.
         * @summary List events for given actors (Patients or Staff). Required Scopes: mami-event-list
         * @param {EventListPayloadDTO} eventListPayloadDTO A payload that contains actor_ids, event_names, limit, and sort_by
         * @param {string} [program] A program to filter for actors by
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v1ListPost(eventListPayloadDTO, program, options) {
            return localVarFp.v1ListPost(eventListPayloadDTO, program, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {Array<TrackEventPayloadDTO>} trackEventPayloadDTO Details about the events in question, and their context.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2TrackBatchPost(trackEventPayloadDTO, options) {
            return localVarFp.v2TrackBatchPost(trackEventPayloadDTO, options).then((request) => request(axios, basePath));
        },
        /**
         * Report one event MAMI which validates and records it.
         * @param {TrackEventPayloadDTO} trackEventPayloadDTO
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        v2TrackPost(trackEventPayloadDTO, options) {
            return localVarFp.v2TrackPost(trackEventPayloadDTO, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * DefaultApi - object-oriented interface
 * @export
 * @class DefaultApi
 * @extends {BaseAPI}
 */
class DefaultApi extends base_1.BaseAPI {
    /**
     * Report on the status of mami service, in the given environment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    v1HealthGet(options) {
        return exports.DefaultApiFp(this.configuration).v1HealthGet(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Lists actors\' events. Optionally filtered by event names and/or program. Adds limits to queries per actor and ability sort by value.
     * @summary List events for given actors (Patients or Staff). Required Scopes: mami-event-list
     * @param {EventListPayloadDTO} eventListPayloadDTO A payload that contains actor_ids, event_names, limit, and sort_by
     * @param {string} [program] A program to filter for actors by
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    v1ListPost(eventListPayloadDTO, program, options) {
        return exports.DefaultApiFp(this.configuration).v1ListPost(eventListPayloadDTO, program, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {Array<TrackEventPayloadDTO>} trackEventPayloadDTO Details about the events in question, and their context.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    v2TrackBatchPost(trackEventPayloadDTO, options) {
        return exports.DefaultApiFp(this.configuration).v2TrackBatchPost(trackEventPayloadDTO, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Report one event MAMI which validates and records it.
     * @param {TrackEventPayloadDTO} trackEventPayloadDTO
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultApi
     */
    v2TrackPost(trackEventPayloadDTO, options) {
        return exports.DefaultApiFp(this.configuration).v2TrackPost(trackEventPayloadDTO, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.DefaultApi = DefaultApi;
